(function(){
 function init(){
  var overlay=document.querySelector("[data-zd-overlay]");
  if(!overlay||overlay.dataset.zdReady==="1")return;
  if(overlay.parentElement!==document.body)document.body.appendChild(overlay);
  var panel=overlay.querySelector(".zd-calc-panel"),closeBtn=overlay.querySelector("[data-zd-close]");
  var w=overlay.querySelector("[data-zd-width]"),h=overlay.querySelector("[data-zd-height]");
  var area=overlay.querySelector("[data-zd-area]"),rolls=overlay.querySelector("[data-zd-rolls]");
  var rollSize=overlay.querySelector("[data-zd-roll-size]"),rollCoverage=overlay.querySelector("[data-zd-roll-coverage]");
  var apply=overlay.querySelector("[data-zd-apply]"),feedback=overlay.querySelector("[data-zd-feedback]");
  var node=document.querySelector("[data-zd-variant-data]"),variants=[];
  try{variants=node?JSON.parse(node.textContent||"[]"):[];}catch(e){variants=[];}
  if(!panel||!closeBtn||!w||!h||!area||!rolls||!apply)return;
  var previousFocus=null,previousOverflow="";
  function currentVariant(){
   var form=document.querySelector('product-info form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');
   var input=form?form.querySelector('input[name="id"]'):document.querySelector('input[name="id"]');
   if(!input)return null;
   return variants.find(function(v){return String(v.id)===String(input.value);})||null;
  }
  function rollInfo(){
   var v=currentVariant();
   var raw=v?(v.option2||(Array.isArray(v.options)?v.options[1]:"")):"40cmX3M";
   var match=String(raw||"40cmX3M").match(/40cmX(\d+)M/i);
   var length=match?Number(match[1]):3;
   return {variant:v,length:length,sqft:0.4*length*10.7639104167,available:!v||v.available!==false};
  }
  function calculate(){
   var width=parseFloat(w.value),height=parseFloat(h.value),roll=rollInfo();
   if(rollSize)rollSize.textContent="Selected roll · 40 cm × "+roll.length+" m";
   if(rollCoverage)rollCoverage.textContent="Approx. "+roll.sqft.toFixed(1)+" sq. ft. before trimming";
   if(!Number.isFinite(width)||!Number.isFinite(height)||width<=0||height<=0){
    area.textContent="—";rolls.textContent="Enter dimensions";apply.disabled=true;return null;
   }
   var squareFeet=width*height;
   area.textContent=squareFeet.toFixed(1)+" sq. ft.";
   if(!roll.available){
    rolls.textContent="Currently unavailable";apply.disabled=true;
    if(feedback)feedback.textContent="This color and roll length are currently unavailable. Choose an available variant before calculating a purchase quantity.";
    return null;
   }
   var count=Math.max(1,Math.ceil(squareFeet*1.10/roll.sqft));
   rolls.textContent=count+" roll"+(count===1?"":"s");apply.disabled=false;
   if(feedback)feedback.textContent="Quantity will be set to "+count+" roll"+(count===1?"":"s")+". You can still change it before adding to cart.";
   return {area:squareFeet,count:count,length:roll.length};
  }
  function open(){
   previousFocus=document.activeElement;previousOverflow=document.body.style.overflow;
   overlay.classList.add("is-open");overlay.setAttribute("aria-hidden","false");document.body.style.overflow="hidden";
   calculate();
   if(window.matchMedia("(min-width: 750px)").matches)panel.focus({preventScroll:true});
  }
  function close(){
   overlay.classList.remove("is-open");overlay.setAttribute("aria-hidden","true");document.body.style.overflow=previousOverflow;
   if(previousFocus&&typeof previousFocus.focus==="function")previousFocus.focus({preventScroll:true});
  }
  document.querySelectorAll("[data-zd-open]").forEach(function(btn){
   if(btn.dataset.zdBound==="1")return;
   btn.dataset.zdBound="1";btn.addEventListener("click",open);
  });
  closeBtn.addEventListener("click",close);
  overlay.addEventListener("click",function(e){if(e.target===overlay)close();});
  document.addEventListener("keydown",function(e){if(e.key==="Escape"&&overlay.classList.contains("is-open"))close();});
  w.addEventListener("input",calculate);h.addEventListener("input",calculate);
  document.addEventListener("change",function(e){if(e.target&&e.target.name==="id"&&overlay.classList.contains("is-open"))calculate();});
  apply.addEventListener("click",function(){
   var result=calculate();if(!result)return;
   var form=document.querySelector('product-info form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');
   var quantity=form?form.querySelector('quantity-input input[name="quantity"],input[name="quantity"]'):document.querySelector('quantity-input input[name="quantity"],input[name="quantity"]');
   if(!quantity){if(feedback)feedback.textContent="Estimated "+result.count+" rolls. Please set this amount in the quantity selector.";return;}
   quantity.value=String(result.count);
   quantity.dispatchEvent(new Event("input",{bubbles:true}));quantity.dispatchEvent(new Event("change",{bubbles:true}));
   if(feedback)feedback.textContent="Quantity set to "+result.count+" roll"+(result.count===1?"":"s")+". Review it before adding to cart.";
   close();if(quantity.scrollIntoView)quantity.scrollIntoView({behavior:"smooth",block:"center"});
  });
  overlay.dataset.zdReady="1";calculate();
 }
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
 document.addEventListener("shopify:section:load",init);
})();